let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8fZau")).then(() => parcelRequire('8z0yN'));